import React, {useState} from 'react';
import './accordion.scss'

interface Props {
    title?: string,
    services?: {
        id?: number,
        title?: string,
        price?: string,
        description?: {
            id?: number,
            description?: string,
            price_departure?: string,
            price_city?: string,
            price_postscript?: string,
            time?: string
        }
    }[]
}

const Accordion = ({title, services}: Props) => {
    const [activeAccordion, setActiveAccordion] = useState<number | null>(null)

    const toggleAccordion = (index: number) => {
        setActiveAccordion(activeAccordion === index ? null : index)
    }

    return (
        <section className={'accordion'}>
            <h2 className={'accordion-title'}>{title}</h2>
            <div className={'accordion-list'}>
                {services?.map((i, index) => {
                    return(
                        <figure key={i.id} className={'figure'}>
                            <section
                                className={`accordion_list_header ${activeAccordion === index ? 'active' : ''}`}
                                onClick={() => toggleAccordion(index)}
                            >
                            <figcaption className={'accordion_list_header_title'}>{i.title}</figcaption>
                            <figcaption className={'accordion_list_header_price'}>
                                <div>
                                <span className={i.price === 'Договорная стоимость' ? 'hide-element' : 'accordion_list_header_price_ot'}>от </span>
                                <span className={'accordion_list_header_price_text'}>{i.price}</span>
                                </div>
                                <span className={'accordion_list_header_price_detail'}>Подробнее</span>
                            </figcaption>
                            </section>

                            {/*Тело*/}
                            <section className={`accordion_list_body ${activeAccordion === index ? 'open' : 'closed'}`}>
                                <div className={'accordion_list_body_theme'}>
                                    <p className={'accordion_list_body_theme_desc'}>{i.description?.description}</p>
                                    <p className={'accordion_list_body_theme_time'}>{i.description?.time}</p>
                                </div>
                                <div className={'accordion_list_body_down'}>
                                    <div className={'accordion_list_body_down_price'}>
                                        <p className={'accordion_list_body_down_price_place'}>На выезде</p>
                                        <div className={'accordion_list_body_down_price_place_box'}>
                                            <p className={'accordion_list_body_down_price_count'}>{i.description?.price_departure}</p>
                                            <p
                                                className={'accordion_list_body_down_price_postscript'}
                                            >{i.description?.price_postscript}</p>
                                        </div>
                                    </div>
                                    <div className={'accordion_list_body_down_price'}>
                                        <p className={'accordion_list_body_down_price_place'}>В Ростове-на-Дону</p>
                                        <div className={'accordion_list_body_down_price_place_box'}>
                                            <p className={'accordion_list_body_down_price_count'}>{i.description?.price_city}</p>
                                            <p className={'accordion_list_body_down_price_postscript'}>{i.description?.price_postscript}</p>
                                        </div>
                                    </div>
                                    <p className={'accordion_list_body_theme_time_mobile'}>{i.description?.time}</p>
                                </div>
                            </section>
                        </figure>
                    )
                })}
            </div>
        </section>
    );
};

export default Accordion;